import {Component} from 'react'
import {Link, withRouter} from 'react-router-dom'
import Cookies from 'js-cookie'
import {FiMenu} from 'react-icons/fi'
import {MdClose} from 'react-icons/md'

import MoodTrackerContext from '../../context/MoodTrackerContext'

import './index.css'

class Header extends Component {
  state = {isMenu: false}

  onMenuClick = () => {
    this.setState(prev => ({isMenu: !prev.isMenu}))
  }

  onLogout = () => {
    const {history} = this.props
    Cookies.remove('jwt_token')
    history.replace('/login')
  }

  render() {
    const {isMenu} = this.state
    const newClassName = isMenu ? 'navbar-menu' : 'nav-content-lg'

    return (
      <MoodTrackerContext.Consumer>
        {value => {
          const {onHomeClick, onReportClick} = value

          return (
            <>
              <nav className="navbar">
                <h1 className="nav-heading">Daily Mood Tracker</h1>
                <div className="nav-content-sm">
                  <button
                    className="menu-button"
                    type="button"
                    onClick={this.onMenuClick}
                    data-testid="menuButton"
                  >
                    {isMenu ? (
                      <MdClose className="icon" />
                    ) : (
                      <FiMenu className="icon" />
                    )}
                  </button>
                </div>
                <div className={newClassName}>
                  <ul className="navbar-menu-content">
                    <Link onClick={onHomeClick} className="link" to="/">
                      <li className="nav-li">Home</li>
                    </Link>
                    <Link
                      onClick={onReportClick}
                      className="link"
                      to="/reports"
                    >
                      <li className="nav-li">Reports</li>
                    </Link>
                    <li>
                      <button
                        type="button"
                        onClick={this.onLogout}
                        className="logout-button"
                      >
                        Logout
                      </button>
                    </li>
                  </ul>
                </div>
              </nav>
            </>
          )
        }}
      </MoodTrackerContext.Consumer>
    )
  }
}

export default withRouter(Header)
